import type VectorLayer from 'ol/layer/Vector';
import type VectorSource from 'ol/source/Vector';

export abstract class NoraLayerManager {
  abstract readonly LAYER_ID: string;
  abstract readonly LAYER_NAME: string;

  /**
   * Whether features on this layer should show a pointer cursor on hover.
   * Override with `true` in subclasses to enable clickable cursor behavior.
   */
  readonly isClickable: boolean = false;

  abstract getLayer(): VectorLayer<VectorSource>;

  setup(): void | Promise<void> {
    // Optional setup method for layer managers.
  }

  /**
   * Load/reload layer data. Implementations should clear existing data before loading.
   * This is the main method for loading layer content.
   */
  load(): void | Promise<void> {
    // Default implementation - subclasses should override
  }

  /**
   * Unload/clear all layer data.
   */
  unload(): void {
    // Default implementation - subclasses should override
  }
}
